import React from 'react';
import Grid from '@mui/material/Grid2';
import CommonPage from "../common/CommonPage";
import VideoPlayer from '../common/VideoPlayer';
import MediaGrid from '../common/MediaGrid';
import { useMediaPlayer } from '../../../hooks/mediaplayer/useMediaPlayer';
import { useGetFavorites } from '../../../hooks/favorites/useGetFavorites';
import { useFavoriteIds } from '../../../hooks/favorites/useFavoriteIds';
import { useToggleFavorite } from '../../../hooks/favorites/useToggleFavorite';
import { useToggleLike } from '../../../hooks/media/useToggleLike';
import { useShareHandler } from '../../../hooks/common/useShareHandler';
import { useDeleteMedia } from '../../../hooks/media/useDeleteMedia';
import { useReportMedia } from '../../../hooks/media/useReportMedia';
import { useBlockMedia } from '../../../hooks/media/useBlockMedia';
import { useBlockUser } from '../../../hooks/media/useBlockUser';

const FavoritesPage = () => {
    const favoritesData = useGetFavorites();
    const favoriteIds = useFavoriteIds();
    const { toggleFavorite } = useToggleFavorite();
    const { toggleLike } = useToggleLike();
    const { handleDeleteMedia } = useDeleteMedia();
    const { handleReportMedia } = useReportMedia();
    const { handleBlockMedia } = useBlockMedia();
    const { handleBlockUser } = useBlockUser();
    const { selectedMediaId, currentVideoUrl, playerMessage, handleMediaSelect } = useMediaPlayer();
    const { handleShare, ShareSnackbar } = useShareHandler();

    return (
        <CommonPage>
            {ShareSnackbar}
            <Grid container spacing={2}>
                <Grid
                    size={{ xs: 12, lg: 4 }}
                    sx={{
                        position: 'sticky',
                        top: (theme) => `calc(${theme.mixins.toolbar.minHeight}px + 16px)`,
                        alignSelf: 'flex-start',
                        height: '50vh'
                    }}
                >
                    <VideoPlayer url={currentVideoUrl} message={playerMessage} />
                </Grid>
                <Grid size={{ xs: 12, lg: 8 }}>
                    <MediaGrid
                        mediaPoints={favoritesData}
                        onCardClick={handleMediaSelect}
                        selectedMediaId={selectedMediaId}
                        favoriteIds={favoriteIds}
                        onToggleFavorite={toggleFavorite}
                        onToggleLike={toggleLike}
                        onShareClick={handleShare}
                        onDeleteClick={handleDeleteMedia}
                        onReportClick={handleReportMedia}
                        onBlockClick={handleBlockMedia}
                        onBlockUserClick={handleBlockUser}
                        gridItemProps={{ xs: 12, sm: 6, md: 4 }}
                    />
                </Grid>
            </Grid>
        </CommonPage>
    );
};

export default FavoritesPage;